const render = ({aff_id, sid}) => {
    return `
    <iframe src="//www.technosystem06.com/PA?sid=${sid}&affid=${aff_id}&SubID={pe_key}&fname={firstName}&email={email}&sessionid={pe_key}&zip={zip}" width="100%" height="875px"frameborder="0" scrolling="no" onload="scroll(0,0);"></iframe>
    `.trim()
  };
  
  export default render;